import { render, staticRenderFns } from "./content-modules-card.vue?vue&type=template&id=10aa6598"
import script from "./content-modules-card.vue?vue&type=script&lang=js"
export * from "./content-modules-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports